import moment from "moment";

export const isFieldExpired = (expirationDate) => {
  const currentTime = moment().format();
  return moment(currentTime).isAfter(expirationDate);
};
